module.exports = __webpack_public_path__ + "img/icon20.cf77b96a.png";